// Baseado no projeto tempo-design-tokens Url(https://dev.azure.com/hsl-dev/Tempo%20-%20Design%20System/_git/tempo-design-tokens)
// Copia do Arquivo: node_modules\@tempo\tempo-tokens\dist\js\globals.js
// Data: 23/08/2023
// @Author: Pedro Freitas - Hospital Sírio-Libanês
// Obs: Arquivo criado devido a incompatibildiade de componentes do Design System Tempo com o typescript
export interface GlobalTokensProps {

    //Borders
    BorderRadiusNone: string;
    BorderRadiusSm: string;
    BorderRadiusMd: string;
    BorderRadiusLg: string;
    BorderRadiusPill: string;
    BorderRadiusCircular: string;
    BorderWidthNone: string;
    BorderWidthHairline: string;
    BorderWidthThin: string;
    BorderWidthThick: string;
    BorderWidthHeavy: string;
    
    //Font
    FontSizeXxs: string;
    FontSizeXs: string;
    FontSizeSm: string;
    FontSizeMd: string;
    FontSizeLg: string;
    FontSizeXl: string;
    FontSizeXxl: string;

    //Line
    LineHeightDefault: string;
    LineHeightXs: string;
    LineHeightSm: string;
    LineHeightMd: string;
    LineHeightLg: string;
    
    //Opacity
    OpacityLevelSemiopaque: number | string;
    OpacityLevelIntense: number | string;
    OpacityLevelMedium: number | string;
    OpacityLevelLight: number | string;
    OpacityLevelSemitransparent: number | string;
    
    //Shadow
    ShadowLevel1: string;
    ShadowLevel2: string;
    ShadowLevel3: string;
    
    //Spacings
    SpacingInsetSizeQuarck: string;
    SpacingInsetSizeNano: string;
    SpacingInsetSizeXs: string;
    SpacingInsetSizeSm: string;
    SpacingInsetSizeMd: string;
    SpacingInsetSizeLg: string;
    SpacingSizeQuarck: string;
    SpacingSizeNano: string;
    SpacingSizeXxxs: string;
    SpacingSizeXxs: string;
    SpacingSizeXs: string;
    SpacingSizeSm: string;
    SpacingSizeMd: string;
    SpacingSizeLg: string;
    SpacingSizeXl: string;
    SpacingSizeXxl: string;
    SpacingSizeXxxl: string;
    SpacingSizeHuge: string;
    SpacingSizeGiant: string;

    //Motions
    MotionSwitchSlow: MotionSwitchSlowProps;
}


export const GlobalTokens: Partial<GlobalTokensProps> = {

    //Borders
    BorderRadiusNone: "0px",
    BorderRadiusSm: "4px",
    BorderRadiusMd: "8px",
    BorderRadiusLg: "16px",
    BorderRadiusPill: "500px",
    BorderRadiusCircular: "50%",
    BorderWidthNone: "0px",
    BorderWidthHairline: "1px",
    BorderWidthThin: "2px",
    BorderWidthThick: "4px",
    BorderWidthHeavy: "8px",

    //Font
    FontSizeXxs: "14px",
    FontSizeXs: "16px",
    FontSizeSm: "20px",
    FontSizeMd: "24px",
    FontSizeLg: "32px",
    FontSizeXl: "48px",
    FontSizeXxl: "64px",

    //LineHeight
    LineHeightDefault: "100%",
    LineHeightXs: "116%",
    LineHeightSm: "124%",
    LineHeightMd: "133%",
    LineHeightLg: "150%",

    //Opacity
    OpacityLevelSemiopaque: 0.72,
    OpacityLevelIntense: 0.64,
    OpacityLevelMedium: 0.32,
    OpacityLevelLight: 0.16,
    OpacityLevelSemitransparent: 0.08,

    //Shadow
    ShadowLevel1: "0px 4px 8px",
    ShadowLevel2: "0px 8px 24px",
    ShadowLevel3: "0px 16px 48px",
    
    //Spacing
    SpacingInsetSizeQuarck: "4px",
    SpacingInsetSizeNano: "8px",
    SpacingInsetSizeXs: "16px",
    SpacingInsetSizeSm: "24px",
    SpacingInsetSizeMd: "32px",
    SpacingInsetSizeLg: "40px",
    SpacingSizeQuarck: "4px",
    SpacingSizeNano: "8px",
    SpacingSizeXxxs: "16px",
    SpacingSizeXxs: "24px",
    SpacingSizeXs: "32px",
    SpacingSizeSm: "40px",
    SpacingSizeMd: "48px",
    SpacingSizeLg: "56px",
    SpacingSizeXl: "64px",
    SpacingSizeXxl: "80px",
    SpacingSizeXxxl: "120px",
    SpacingSizeHuge: "160px",
    SpacingSizeGiant: "200px",

    //Motions - switch-slow
    MotionSwitchSlow: {
        TransitionDuration: "0.275s",
        TransitionTimingFunction: "cubic-bezier(0.48, 0, 0.48, 1)"
    },
}

export interface MotionSwitchSlowProps {
    TransitionDuration: number | string
    TransitionTimingFunction: number | string
}

// export const headerHeight = '56px'

// export interface Sizes {
//     XXS: number | string
//     XS: number | string
//     S: number | string
//     M: number | string
//     L: number | string
//     XL: number | string
//     XXL: number | string
// }

// export const gapSizes: Partial<Sizes> = {
//     S: '10px',
//     M: '20px',
//     L: '30px',
//     XL: '40px',
//     XXL: '50px',
// }

// export const screenSizes: Partial<Sizes> = {
//     XS: 480,
//     S: 640,
//     M: 800,
//     L: 1024,
//     XL: 1280,
// }

// export const fontSizes: Sizes = {
//     XXS: '14px',
//     XS: '16px',
//     S: '18px',
//     M: '24px',
//     L: '32px',
//     XL: '36px',
//     XXL: '48px',
// }

// export const lineHeights: Sizes = {
//     XXS: '14px',
//     XS: '24px',
//     S: '18px',
//     M: '24px',
//     L: '32px',
//     XL: '36px',
//     XXL: '48px',
// }

// export const textAreaSizes = {
//     S: '92px',
//     M: '108px',
//     L: '128px',
// }

// interface ThemeWithStates {
//     [propName: string]: string
// }

// export interface Colors {
//     darkNavy: string
//     navy: string
//     lightNavy: string
//     white: string
//     gray: string
//     error: string
//     bannerError: string
//     black: string
//     green: string
//     blueLight: string
//     blueMed: string
//     blueDark: string
//     bannerSuccess: string
//     grayDivider: string

    
// }

// export const colors: Colors = {
//     darkNavy: '#262A36',
//     navy: '#2C3040',
//     lightNavy: '#394E5B',
//     white: '#ffffff',
//     gray: '#f4f4f4',
//     black: '#000000',
//     error: '#D0021B',
//     green: '#33AA40',
//     blueDark: '#2B3B44',
//     blueMed: '#2C3E50',
//     blueLight: '#3292C0',
//     bannerError: '#FFC6CC',
//     bannerSuccess: '#A9F3B0',
//     grayDivider: '#435763',
// }
 